const VIBE_SECTION_SELECTOR = '[data-bestseller-vibe-section]';

interface RegisterVibeReturnScrollRestoreParams {
  pageUrl: string;
}

function getCurrentPageUrl() {
  return `${window.location.pathname}${window.location.search}`;
}

export function registerVibeReturnScrollRestore({
  pageUrl,
}: RegisterVibeReturnScrollRestoreParams) {
  const section = document.querySelector<HTMLElement>(VIBE_SECTION_SELECTOR);
  if (!section) return;

  const sectionViewportTop = section.getBoundingClientRect().top;
  let restoring = false;

  const restoreSectionPosition = () => {
    const restoredSection = document.querySelector<HTMLElement>(VIBE_SECTION_SELECTOR);
    if (!restoredSection) return;

    const offset = restoredSection.getBoundingClientRect().top - sectionViewportTop;
    if (Math.abs(offset) < 0.5) return;

    window.scrollTo({
      top: Math.max(0, window.scrollY + offset),
      left: 0,
      behavior: 'auto',
    });
  };

  const handlePageReturn = () => {
    if (restoring) return;

    window.removeEventListener('popstate', handlePageReturn);
    window.removeEventListener('pageshow', handlePageReturn);

    if (getCurrentPageUrl() !== pageUrl) return;
    restoring = true;

    // 连续校正覆盖 Next.js 路由恢复、响应式图片及上方榜单回填造成的布局变化。
    restoreSectionPosition();
    window.requestAnimationFrame(() => {
      restoreSectionPosition();
      window.requestAnimationFrame(restoreSectionPosition);
    });
    window.setTimeout(restoreSectionPosition, 100);
    window.setTimeout(restoreSectionPosition, 300);
  };

  window.addEventListener('popstate', handlePageReturn);
  window.addEventListener('pageshow', handlePageReturn);
}
